import { b64toBlob } from './../../PrintPDF/common/utils';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IExtract, IExtractType } from '../../../common/sharedTypes';

import * as urls from '../../shared/urls';
// types
export enum ExtractActionTypes {
  SEARCH = '@@extractsadmin/SEARCH',
  GENERATE = '@@extractsadmin/GENERATE',
  REGENERATE = '@@extractsadmin/REGENERATE',
  SEND = '@@extractsadmin/SEND',
  EXTRACT_TYPES = '@@extractsadmin/EXTRACT_TYPES',
}

export const extractSearch = (url: string) => {
  return async (dispatch) => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceResults = (result: IExtract[]) => {
  return {
    type: ExtractActionTypes.SEARCH,
    value: result,
  };
};

export const getExtractTypes = (url: string) => {
  return async (dispatch) => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(reduceExtractTypes(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceExtractTypes = (result: IExtractType[]) => {
  return {
    type: ExtractActionTypes.EXTRACT_TYPES,
    value: result,
  };
};

export const regenerateExtract =
  (
    url: string,
    extractId: number,
    comment: string,
    sendToCarfax: boolean,
    sendToExperian: boolean,
    sendToTruckBus: boolean,
    sendToFarsNhtsa: boolean,
    sendToLawFirm: boolean,
    sendToNdotSftp: boolean
  ) =>
  (dispatch) =>
    new Promise(function (resolve, reject) {
      Api.post(url, {
        extractId,
        comment,
        sendToCarfax,
        sendToExperian,
        sendToTruckBus,
        sendToFarsNhtsa,
        sendToLawFirm,
        sendToNdotSftp,
      })
        .then((result: ApiResponse<any>) => {
          if (result.ok && result.status == 200) {
            dispatch(reduceRegenerate(result.data));
            resolve(result);
          } else {
            reject(result.data);
          }
        })
        .catch(function (ex) {
          //console.log(ex);
          reject(ex);
        })
        .finally(function () {
          resolve();
        });
    });

export const reduceRegenerate = (result: IExtract) => {
  return {
    type: ExtractActionTypes.REGENERATE,
    value: result,
  };
};

export const generateExtract =
  (
    url: string,
    extractTypeId: number,
    comment: string,
    startDate: string,
    endDate: string,
    sendToCarfax: boolean,
    sendToExperian: boolean,
    sendToTruckBus: boolean,
    crashKey: string,
    sendToFarsNhtsa: boolean,
    sendToLawFirm: boolean,
    sendToNdotSftp: boolean,
    extractSubTypeId: number,
    snapshotDatabaseId: number
  ) =>
  (dispatch) =>
    new Promise(function (resolve, reject) {
      Api.post(url, {
        extractTypeId,
        comment,
        startDate,
        endDate,
        sendToCarfax,
        sendToExperian,
        sendToTruckBus,
        crashKey,
        sendToFarsNhtsa,
        sendToLawFirm,
        sendToNdotSftp,
        extractSubTypeId,
        snapshotDatabaseId,
      })
        .then((result: ApiResponse<any>) => {
          if (result.ok && result.status == 200) {
            dispatch(reduceGenerate(result.data));
            resolve(result);
          } else {
            reject(result.data);
          }
        })
        .catch(function (ex) {
          //console.log(ex);
          reject(ex);
        })
        .finally(function () {
          resolve();
        });
    });

export const reduceGenerate = (result: IExtract) => {
  return {
    type: ExtractActionTypes.GENERATE,
    value: result,
  };
};

export const viewData = (extractId: number) => {
  const zipSubTypes = [3, 4];
  return new Promise((resolve, reject) => {
    Api.get(`${urls.GET_EXTRACT}?extractId=${extractId}`)
      .then((response: ApiResponse<any>) => {
        //console.log('pdf response', response);
        if (response.data) {
          var extract = response.data;
          if (
            extract.extractTypeId == 5 &&
            zipSubTypes.some((t) => t === extract.extractSubTypeId)
          ) {
            // Zip file full of cvs files
            const file = b64toBlob(extract.data, 'application/zip');
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else if (extract.extractTypeId == 4) {
            // type 4 is pdf of redacted image for lawfirm
            const file = b64toBlob(extract.data, 'application/pdf');
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            // types 1-3 are xml
            let blob = new Blob([extract.data], { type: 'text/xml' });
            let url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url); //Releases the resources
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve();
      });
  });
};
